module.exports = __webpack_public_path__ + "static/media/playhead-in.dadcfc27.svg";